import { Platform } from "react-native";
import { UserLoggedInNavigatorScreenProps } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { HeaderButton } from "../../components";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { AllFilesScreen } from "./AllFilesScreen";
import { FileStack } from "./FileStack";
import { FilesScreen } from "./FilesScreen";

export function FileNavigator(
  props: UserLoggedInNavigatorScreenProps<"Files">
) {
  const intl_tokens = useIntlTokens();
  return (
    <FileStack.Navigator>
      <FileStack.Screen
        name="FilesMain"
        component={FilesScreen}
        options={{
          title: intl_tokens.Files,
          headerLeft:
            Platform.OS === "ios"
              ? () => (
                  <HeaderButton
                    type="CLOSE"
                    onPress={props.navigation.goBack}
                  />
                )
              : undefined,
        }}
      />

      <FileStack.Screen
        name="AllFiles"
        component={AllFilesScreen}
        options={({ route: { params } }) => ({
          title: intl_tokens.AllFiles,
          headerLeft:
            params.standalone && Platform.OS === "ios"
              ? () => (
                  <HeaderButton type="BACK" onPress={props.navigation.goBack} />
                )
              : undefined,
        })}
      />
    </FileStack.Navigator>
  );
}
